module.exports = __webpack_public_path__ + "img/wayfinder-mobile-map-fr.9d4b1604.png";